<template>
  <div class="page">
    <div class="content">
      <div><i class="el-icon-guide"></i> 404 Not Found</div>
      <div class="text">未找到该页面</div>
      <div class="text">请尝试访问主页</div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.page{
  height: 100%;
  width: 100%;
  min-height: 500px;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  justify-content: center;
}
.content{
  margin: auto;
  text-align: center;
  font-size: 40px;
  font-weight: 300;
  line-height: 60px;
}
</style>
